import { ACTIVITY_LOGS_LOAD_QUERY_PARAMETERS,
   INVOICE_LOAD_QUERY_PARAMETERS,
  CUSTOMERS_LOAD_QUERY_PARAMETERS } from "./page_load_query_params";
import { QUERY_PARAMETERS } from "@/constants";
import { ACTIVITY_LOG_PARAMS, INVOICE_PARAMS, CUSTOMERS_PARAMS } from "./entity_query_params";

const MUTATIONS = Object.freeze({
  APPEND_OR_UPDATE_QUERY_PARAMETER: "appendParameter",
  DELETE_QUERY_PARAMETER: "deleteParameter",
  CLEAR_QUERY_PARAMETERS: "resetParameters",
  PARSE_QUERY_PARAMETERS: "parseQueryParameters",
});

export const QUERY_PARAMETERS_ACTIONS = Object.freeze({
  ADD_FILTER_QUERY_PARAMETER: "addFilterQueryParameter",
  REMOVE_QUERY_PARAMETER: "removeQueryParameter",
  RESET_QUERY_PARAMS_WITH_FIRST_PAGE:
  "resetQueryParamsWithFirstPage",
  RESET_QUERY_PARAMS: "resetQueryParams",

  REMOVE_PARAMS_FROM_URL: "removeParams",
  APPLY_CURRENT_PARAMS_TO_URL: "applyParams",
});


export default {
  namespaced: true,
  state: {
    params: new Map(),
  },
  mutations: {
    [MUTATIONS.APPEND_OR_UPDATE_QUERY_PARAMETER](state, { label, value }) {
      if (value === null) {
        state.params.delete(label);
      } else {
        if (value instanceof Date) {
          value = value.toISOString();
        }
        state.params.set(label, value);
      }
    },
    [MUTATIONS.DELETE_QUERY_PARAMETER](state, label) {
      state.params.delete(label);
    },
    [MUTATIONS.CLEAR_QUERY_PARAMETERS](state) {
      state.params.clear();
    },
    [MUTATIONS.PARSE_QUERY_PARAMETERS](state, { queries, queryEntity }) {
      if (Object.is(queryEntity, INVOICE_LOAD_QUERY_PARAMETERS)) {
        Object.entries(queries).forEach(([key, value]) => {
            if (INVOICE_PARAMS.has(key)) {
                state.params.set(key, value);
            }
        });
      } else if (Object.is(queryEntity, ACTIVITY_LOGS_LOAD_QUERY_PARAMETERS)) {
        Object.entries(queries).forEach(([key, value]) => {
            if (ACTIVITY_LOG_PARAMS.has(key)) {
                state.params.set(key, value);
            }
        });
      } else if (Object.is(queryEntity, CUSTOMERS_LOAD_QUERY_PARAMETERS)) {
        Object.entries(queries).forEach(([key, value]) => {
            if (CUSTOMERS_PARAMS.has(key)) {
                state.params.set(key, value);
            }
        });
      }
    }
  },
  actions: {
    [QUERY_PARAMETERS_ACTIONS.ADD_FILTER_QUERY_PARAMETER]: {
      root: true,
      handler({ commit, state }, payload) {
        return new Promise((resolve) => {
          let currentPath;
          ({currentPath, payload} = payload);
          commit(MUTATIONS.APPEND_OR_UPDATE_QUERY_PARAMETER, {
              label: QUERY_PARAMETERS.PAGE_NO,
              value: 1,
          });
          payload.forEach(param => {
            commit(MUTATIONS.APPEND_OR_UPDATE_QUERY_PARAMETER, { label: param.label, value: param.value });
          });
          history.pushState(
            {},
            null,
            currentPath + "?" + new URLSearchParams(state.params),
            // this.$route.path + "?" + new URLSearchParams(state.params),
          );
          resolve({
            ...Object.fromEntries(state.params),
          });
        });
      },
    },
    [QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS_WITH_FIRST_PAGE]: {
      root: true,
      handler({ commit, state }, {pageLoadVarsConstant, currentPageQueries}) {
        return new Promise((resolve) => {
          commit(MUTATIONS.CLEAR_QUERY_PARAMETERS);
          if (Object.keys(currentPageQueries).length !== 0) {
            commit(MUTATIONS.PARSE_QUERY_PARAMETERS, {
              // queries: router.currentRoute.query,
              queries: currentPageQueries,
              queryEntity: pageLoadVarsConstant,
            });
          } else {
            const labels = [QUERY_PARAMETERS.PAGE_NO, QUERY_PARAMETERS.START_TIME, QUERY_PARAMETERS.END_TIME, QUERY_PARAMETERS.SORT];

            labels.forEach((label) => {
              if (Object.hasOwnProperty.call(pageLoadVarsConstant, label)) {
                commit(MUTATIONS.APPEND_OR_UPDATE_QUERY_PARAMETER, {
                  label: label,
                  value: pageLoadVarsConstant[label]
                });
              }
            });
        }
        resolve({
          ...Object.fromEntries(state.params),
        });
        });
      },
    },
    [QUERY_PARAMETERS_ACTIONS.APPLY_CURRENT_PARAMS_TO_URL]: {
      root: true,
      handler({state}, currentPath) {
        history.pushState(
            {},
            null,
            currentPath + "?" + new URLSearchParams(state.params),
            // this.$route.path + "?" + new URLSearchParams(state.params),
            "adsf"
          );
        return state.params;
      }
    },
    [QUERY_PARAMETERS_ACTIONS.RESET_QUERY_PARAMS]: {
        root: true,
        handler({commit}) {
            return new Promise((resolve) => {
                commit(MUTATIONS.CLEAR_QUERY_PARAMETERS);
                resolve(true);
            });
        }
    },
    [QUERY_PARAMETERS_ACTIONS.REMOVE_PARAMS_FROM_URL]: {
      root: true,
      handler({state}, currentPath) {
        history.pushState(
            {},
            null,
            currentPath.split("?")[0],
            // this.$route.path.split("?")[0],
          );
        return state.params;
      }
    },
  },
  getters: {},
};
